import { EN } from 'lib/locales';

import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * get user data from back-end
 * @returns {Promise<Response>} the response object
 */
export const getUser = function getUserData() {
  const url = `${CCS_URL}/user`;
  const headers = authHeaders();
  return betterFetch(url, { headers });
};

/**
 * common code for favorite/unfavorite to build request parameters/options
 * @param {string} contentId - page or folder or component id
 * @param {string} contentType - page or folder or component
 * @param {string} locale - locale
 * @returns {object} the parameters required to make call
 */
const buildFavoriteRequest = function buildRequest(contentId, contentType, locale) {
  const headers = authHeaders();
  const options = {
    method: 'PUT',
    headers
  };

  const queryParams = new URLSearchParams({
    contentId,
    contentType,
    locale
  });

  return {
    options,
    queryParams
  };
};

/**
 * favorites page, folder, or component
 * @param {string} contentId - page or folder or component id
 * @param {string} contentType - page or folder or component
 * @param {string} locale - locale
 * @returns {Promise<Response>} the response object
 */
export const favoriteContent = function favoriteContent(contentId, contentType, locale = EN) {
  const { options, queryParams } = buildFavoriteRequest(contentId, contentType, locale);
  const url = `${CCS_URL}/user/favorite?${queryParams}`;

  return betterFetch(url, options);
};

/**
 * unfavorites page, folder, or component
 * @param {string} contentId - page or folder or component id
 * @param {string} contentType - page or folder or component
 * @param {string} locale - locale
 * @returns {Promise<Response>} the response object
 */
export const unfavoriteContent = function unfavoriteContent(
  contentId,
  contentType,
  locale = EN
) {
  const { options, queryParams } = buildFavoriteRequest(contentId, contentType, locale);
  const url = `${CCS_URL}/user/unfavorite?${queryParams}`;

  return betterFetch(url, options);
};
